import {
  FETCH_BERBIX_REQUEST_ERROR,
  FETCH_BERBIX_REQUEST_REQUEST,
  FETCH_BERBIX_REQUEST_SUCCESS
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case FETCH_BERBIX_REQUEST_REQUEST:
      return { ...state, ...action.payload };
    case FETCH_BERBIX_REQUEST_SUCCESS:
      return { ...state, ...action.payload };
    case FETCH_BERBIX_REQUEST_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
